import Model from '@/models/Model.js';

export default class ActivityType extends Model {
    static entity = 'activity_types';

    static fields() {
        return {
            id: this.attr(null),
            key: this.attr(null),
            content: this.attr(null),
            submission: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
        };
    }
}
